const actions = {
    GET_OPERATIONS: "GET_OPERATIONS"
}

const initialState = {
    operations: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            userName: "",
            dateFrom: null,
            dateTo: null
        },
    }
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
    case actions.GET_OPERATIONS:
    {
        return {
            ...state,
            operations: action.payload.operations,
            filter: action.payload.filter
        };
    }
    default:
        return state;
    }
};

export const setOperations = (operations, filter) => ({type: actions.GET_OPERATIONS, payload: {operations, filter}})